<template>
  <div>
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <div class="content-header row"></div>
        <div class="content-body">
          <section class="row flexbox-container">
            <div class="col-xl-7 col-md-9 col-10 px-0">
              <div class="card bg-authentication mb-0">
                <div class="row m-0">
                  <!-- left section-forgot password -->
                  <div class="col-md-6 col-12 px-0">
                    <div class="card disable-rounded-right mb-0 p-2">
                      <div class="card-header pb-1">
                        <div class="text-center">
                          <h2>
                            <img
                              src="@/app-assets/images/brand/pacto-logo.png"
                              alt="Pacto Logo"
                              style="width: 160px"
                            />
                          </h2>
                        </div>
                      </div>
                      <div class="card-content">
                        <div class="card-body">
                          <div class="text-muted text-center mb-2">
                            <small>
                              {{$t('Enter the')}} <strong>{{$t('email')}}</strong> {{$t('you used when you joined')}}
                            </small>
                          </div>
                          <div class="text-center" v-if="error == 'required'">
                            <p class="text-danger">
                              {{$t('Please fill out')}} <strong>{{$t('all fields')}}</strong> 😕
                            </p>
                          </div>
                          <div
                            class="text-center"
                            v-if="error == 'email error'"
                          >
                            <p class="text-danger">
                              {{$t('Error sending')}} <strong>{{$t('recovery email')}}</strong> 😕
                            </p>
                          </div>
                          <form class="mb-2">
                            <div class="form-group">
                              <label
                                class="text-bold-600"
                                for="exampleInputEmailPhone1"
                              >
                                {{$t('Email Address')}}
                              </label>
                              <input
                                type="email"
                                class="form-control"
                                id="exampleInputEmailPhone1"
                                placeholder="johndoe@example.com"
                                v-model="emailAddress"
                              />
                            </div>
                            <div class="form-group mb-2">
                              <label class="text-bold-600"> {{$t('Language')}} </label>
                              <select class="form-control" v-model="language">
                                <option value="en">{{$t('English')}}</option>
                                <option value="ar">{{$t('Arabic')}}</option>
                              </select>
                            </div>
                            <button
                              type="button"
                              class="btn btn-primary glow position-relative w-100"
                              @click="recoverPassword()"
                              v-if="!loggingIn"
                            >
                              {{$t('SEND PASSWORD')}}
                              <em
                                id="icon-arrow"
                                class="bx bx-right-arrow-alt"
                              ></em>
                            </button>
                            <button
                              disabled
                              type="submit"
                              class="btn btn-primary glow w-100 position-relative"
                              v-else
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span class="sr-only">{{$t('Loading...')}}</span>
                            </button>
                          </form>
                          <div class="text-center mb-2">
                            <a href="/">
                              <small class="text-muted">
                                {{$t('I remembered my password')}}
                              </small>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- right section image -->
                  <div
                    class="col-md-6 d-md-block d-none text-center align-self-center"
                  >
                    <lottie-player
                      src="https://assets4.lottiefiles.com/packages/lf20_fwykef3x.json"
                      background="transparent"
                      speed="1"
                      style="width: 95%; height: auto; margin: 0 auto;"
                      loop
                      autoplay
                    ></lottie-player>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailAddress: "",
      language: "en",
      loggingIn: false,
      error: "",
    };
  },

  methods: {
    recoverPassword() {
      this.error = false;
      this.loggingIn = false;
      if (this.emailAddress.trim() != "") {
        this.loggingIn = true;
        this.$apiCall
          .post("/v1/auth/send/recover", {
            email: this.emailAddress,
            language: this.language,
          })
          .then((response) => {
            location.href = "/logout";
          })
          .catch((err) => {
            if (err.response.status == 405) {
              this.error = "email error";
            }
          });
      } else {
        this.error = "required";
      }
    },
  },

  mounted() {
    $("body").removeClass(
      "vertical-layout vertical-menu-modern 2-columns navbar-sticky footer-static"
    );
    $("body").addClass(
      "vertical-layout vertical-menu-modern 1-column navbar-sticky footer-static bg-full-screen-image blank-page blank-page"
    );
  },
};
</script>